export enum CalendarFilterOption {
  ASSIGNED_USER = "assignedUserId",
  ASSIGNED_DEPARTMENT = "assignedDepartmentId",
  ENTITY_TYPE = "entityTypeId",
  EVENT_TYPE = "eventType",
}
